import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'
import { concatIf } from '@btime/helpers'
import { useOpenTransferStockItemsModal } from '../../../utils/routes/modals/modalsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconText from '../../../components/presentation/IconText'

const PageHeader = () => {
  const openTransferStockItemsModal = useOpenTransferStockItemsModal()
  const { t } = useTranslation(['common', 'listStocks'])
  const options = [
    ...concatIf(true, [
      {
        value: 'transferItems',
        iconLeft: 'RiArrowLeftRightFill',
        onClick: () => openTransferStockItemsModal()
      }
    ])
  ]
  return (
    <>
      <Separator weight={12} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('listStocks:title')}
          </Title>
        </FlexCol>

        <FlexCol flex={1}></FlexCol>

        {!!options.length && (
          <FlexCol>
            <DropdownLink
              fromRight
              t={key => t(`listStocks:menu.${key}`)}
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </FlexCol>
        )}
      </FlexGrid>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
